import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/sharp-light-svg-icons";
import { pxToRem } from "../../platform-style";

interface CollapseNodeProps {
  title: string;
}

export const CollapseNode = ({ title }: CollapseNodeProps) => {
  return (
    <div aria-expanded={"true"}>
      <FontAwesomeIcon icon={faAngleUp} style={{ marginRight: pxToRem(2) }}></FontAwesomeIcon>{" "}
      {title}
    </div>
  );
};
